import { DepotFormValues } from '../types'
import { createEmptyDepot } from './createEmptyDepot'

export function computeFormInitialValues(
  selectedDepot?: uui.domain.client.rm.Depot,
): DepotFormValues {
  const depot = selectedDepot ?? createEmptyDepot()

  return {
    id: depot.id,
    name: depot.name,
    location: depot.location,
    color: `#${depot.color}`,
    setupCost: Math.max(depot.setupCost / 100, 0),
    setupTime: Math.max(depot.setupTimeSec, 0),
  }
}
